export default __webpack_public_path__ + "static/media/thecavernofmalice.12b20133.jpg";